import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SidebarMenu from "../../../Components/SidebarMenu";
import api from "../../../Services/api";
import { Page } from "../../SignedOut/Cadastro/styles";
import ReactLoading from "react-loading";
import PageContainer from "../../../Components/PageContainer";
import { toast } from "react-toastify";
import {
  PacientInfo,
  InfoBlock,
  InfoTitle,
  Info,
  Content,
  PageTitle,
} from "./styles";
import StatusDisplay from "../../../Components/Status";
import MainButton from "../../../Components/MainButton";
import { useHistory } from "react-router";

export default function ConsultaUnica() {
  const { id } = useParams();
  const [consulta, setConsulta] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingCancelarCobranca, setLoadingCancelarCobranca] = useState(false);
  const [loadingEstornarCredito, setLoadingEstornarCredito] = useState(false);

  const history = useHistory();

  // Para apagar a cobrança
  async function cancelarCobranca() {
    setLoadingCancelarCobranca(true);
    try {
      const response = await api.delete(`/transferencia/excluir-transferencia/${id}`);
      console.log(response);
      const showToastMessage = () => {
        toast.success(`Sucesso ao cancelar a cobrança `, {
          position: toast.POSITION.TOP_CENTER,
        });
      };
      showToastMessage();
      history.goBack()
    } catch (error) {
      const showToastMessageError = () => {
        toast.error(`Não foi possivel completar a operação`, {
          position: toast.POSITION.TOP_CENTER,
        });
      };
      showToastMessageError();
      console.log(error);
    }
    setLoadingCancelarCobranca(false);
  }

  // Para estornar o crédito (devolve ao paciente)
  async function estornarCredito() {
    const confirmar = window.confirm(
      "Tem certeza que deseja estornar este crédito? Os créditos serão devolvidos ao paciente e a transferência será marcada como ESTORNADO."
    );
    if (!confirmar) return;

    setLoadingEstornarCredito(true);
    try {
      const response = await api.patch(`/transferencia/estornar/${id}`);
      console.log(response);
      toast.success(`Crédito estornado com sucesso!`, {
        position: toast.POSITION.TOP_CENTER,
      });
      history.goBack();
    } catch (error) {
      toast.error(`Não foi possível estornar o crédito`, {
        position: toast.POSITION.TOP_CENTER,
      });
      console.log(error);
    }
    setLoadingEstornarCredito(false);
  }

  const fetchRepositoriesData = async () => {
    setLoading(true);

    try {
      const response = await api.get(`/transferencia/detalhes/${id}`);
      setConsulta(response?.data);
      console.log("consulta", response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRepositoriesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return (
      <Page>
        <SidebarMenu />
        <PageContainer>
          <PageTitle>Histórico de Consultas</PageTitle>
          <ReactLoading
            type="spin"
            color="#B2EBF2"
            height={"30px"}
            width={"30px"}
          />
        </PageContainer>
      </Page>
    );
  }

  return (
    <Page>
      <SidebarMenu />
      <PageContainer>
        <PageTitle>Consulta</PageTitle>
        <Content>
          <PacientInfo>
            {consulta?.afiliado && (
              <>
                <InfoBlock>
                  <InfoTitle>Nome do Dependente:</InfoTitle>
                  <Info>{consulta.afiliado.usuario.NO_primeiro_nome ?? "" + " " + consulta.afiliado.usuario.NO_ultimo_nome ?? ""} </Info>
                </InfoBlock>
                <InfoBlock>
                  <InfoTitle>CPF:</InfoTitle>
                  <Info>{consulta?.afiliado.usuario.NU_cpf}</Info>
                </InfoBlock>
              </>
            )}

            {consulta?.paciente &&
              <>
                <InfoBlock>
                  <InfoTitle>Nome do Titular:</InfoTitle>
                  <Info>{consulta.paciente.usuario.NO_primeiro_nome ?? "" + " " + consulta.paciente.usuario.NO_ultimo_nome ?? ""}</Info>
                </InfoBlock>
                <InfoBlock>
                  <InfoTitle>CPF:</InfoTitle>
                  <Info>{consulta?.paciente.usuario.NU_cpf}</Info>
                </InfoBlock>

                <InfoBlock>
                  <InfoTitle>Email:</InfoTitle>
                  <Info>{consulta?.paciente.usuario.DS_email ?? ""}</Info>
                </InfoBlock>

                <InfoBlock>
                  <InfoTitle>Telefone:</InfoTitle>
                  <Info>{consulta?.paciente.usuario.NU_telefone ?? ""}</Info>
                </InfoBlock>
              </>
            }

            <InfoBlock>
              <InfoTitle>Data da consulta:</InfoTitle>
              <Info>{new Date(consulta?.DT_criacao).toLocaleDateString("pt-BR")}</Info>
            </InfoBlock>
          </PacientInfo>

          <PacientInfo>
            <InfoBlock>
              <InfoTitle>Especialidade:</InfoTitle>
              <Info>
                {consulta?.especialidade?.NO_especialidade}
              </Info>
            </InfoBlock>
            <InfoBlock>
              <InfoTitle>Valor da Consulta:</InfoTitle>
              <Info>{consulta?.QT_credito} crédito(s)</Info>
            </InfoBlock>
            <InfoBlock>
              <InfoTitle>Status:</InfoTitle>

              <StatusDisplay status={consulta?.ST_transferencia}>
                {consulta?.ST_transferencia}
              </StatusDisplay>
            </InfoBlock>
            <InfoBlock>
              <InfoTitle>Código do Pagamento:</InfoTitle>

              <Info>{consulta?.CD_token}</Info>
            </InfoBlock>
            {consulta?.ST_transferencia === "PENDENTE" &&
              <InfoBlock>
                <MainButton
                  onClick={() => cancelarCobranca()}
                  disabled={loadingCancelarCobranca}
                  bgcolor="red"
                >
                  {loadingCancelarCobranca
                    ?
                    <ReactLoading
                      type="spin"
                      color="#ffffff"
                      height={"20px"}
                      width={"20px"}
                    />
                    :
                    "Cancelar Cobrança"
                  }
                </MainButton>
              </InfoBlock>}
            {consulta?.ST_transferencia === "SUCESSO" &&
              <InfoBlock>
                <MainButton
                  onClick={() => estornarCredito()}
                  disabled={loadingEstornarCredito}
                  bgcolor="#9333EA"
                >
                  {loadingEstornarCredito
                    ?
                    <ReactLoading
                      type="spin"
                      color="#ffffff"
                      height={"20px"}
                      width={"20px"}
                    />
                    :
                    "Estornar Crédito"
                  }
                </MainButton>
              </InfoBlock>}

          </PacientInfo>
        </Content>
      </PageContainer>
    </Page>
  );
}
